import Tables from './Tables';
import ServicesChartsDataProvider from './contexts/ServicesChartsDataContext';

const ProceduresList = () => {
    return (
        <ServicesChartsDataProvider>
            <Tables />
        </ServicesChartsDataProvider>
    );
};

export default ProceduresList;
